import React, { useEffect, useRef, useState } from "react";

import API from "../../api";


interface UploadableImageInfo {
  idx       : number;
  key       : number;
  src       : any;
  fileRef   : any;
  needUpload: boolean;
  userInfo  : any;
}


export default class UploadableImages {
  private nextKey_:number = 1;
  private size_:number;
  private imgInfos_:UploadableImageInfo[];

  constructor (capacity:number, initialImageUserInfos:any[]=[]) {
    if (initialImageUserInfos.length > capacity)
      initialImageUserInfos = initialImageUserInfos.slice(0, capacity);

    this.size_ = initialImageUserInfos.length;

    this.imgInfos_ = [];
    for (let ii=0; ii<capacity; ++ii) {
      const hasInitialUrl = ii<initialImageUserInfos.length;
      this.imgInfos_.push(
          {
            idx       : ii,
            key       : this._issueKey(),
            src       : (hasInitialUrl)? initialImageUserInfos[ii].url: null,
            fileRef   : null,
            needUpload: !hasInitialUrl,
            userInfo  : (hasInitialUrl)? initialImageUserInfos[ii]: null,
          }
      )
    }
  }


  size ():number { return this.size_; }
  isFull ():boolean { return this.size_ >= this.imgInfos_.length; }

  getImgInfo (idx:number) { return this.imgInfos_[idx]; }

  callUseThings () {
    this._initRefresher();

    for (const info of this.imgInfos_)
      info.fileRef = useRef(null);
  }

  build (desc:string=null, disabled:boolean=false):any {
    const tags = [];


    /// image tags
    for (let ii=0; ii<this.imgInfos_.length; ++ii)
      tags.push(this._buildImageTag(this.imgInfos_[ii], ii<this.size_, disabled));


    /// adder tag
    tags.push(this._buildAdderTag(desc, disabled));

    return (
      <div>
        {tags}
      </div>
    );
  }

  async upload (brandToken:any) {
    const uploadedImgs = [];
    try {
      for (let ii=0; ii<this.size_; ++ii) {
        const info = this.imgInfos_[ii];
        if (info.needUpload === false || !info.fileRef.current) {
          uploadedImgs.push(null);
          continue;
        }

        const img = info.fileRef.current.files[0];
        const res = await API.BrandSns.uploadImage({
          brandToken,
          image: img,
        });
        const imgUrl = res.data.url;
        uploadedImgs.push(imgUrl);
      }
    }catch (err) {
      //TODO remove uploaded images

      uploadedImgs.splice(0, uploadedImgs.length);  // clear array
      throw err;
    }

    return uploadedImgs;
  }



  private _issueKey ():number {
    return this.nextKey_++;
  }

  private refresherValue_:boolean;
  private refresherFunc_:any;
  private _initRefresher () {
    [this.refresherValue_, this.refresherFunc_] = useState(true);
  }
  private _refresh () {
    this.refresherFunc_(!this.refresherValue_);
  }

  private _buildImageTag (info:UploadableImageInfo, visible:boolean, disabled:boolean=false):any {
    return (
        <div key={info.key} className={(visible)? '':'hidden'} data-dummy={this.refresherValue_}>
          <div style={{position:'relative'}}>
            <img
              className="object-contain w-[124px] h-[124px]"
              src={info.src}
            />
            <div className="cursor-pointer">
              <img
                style={{position:'absolute', top:'0px', right:'0px'}}
                src="/assets/icons/ic-close-black-squared.svg"
                onClick={
                    (e) => {
                      if (disabled)
                        return;

                      this._rmImgInfo(info.idx);
                      return this._refresh();
                    }
                }
              />
            </div>
          </div>
          <input
            type="file"
            ref={info.fileRef}
            onChange={
                (elm) => {
                  const file = elm.target.files && elm.target.files[0];
                  if (!file) {
                    this._rmImgInfo(info.idx);
                    return this._refresh();
                  }

                  const reader = new FileReader();
                  reader.onload = (r) => {
                    this._addImgInfo(info.idx);
                    info.src = r.target.result;
                    this._refresh();
                  };
                  reader.readAsDataURL(file);
                }
            }
            style={{ display: "none" }}
          />
        </div>
    );
  }

  private _buildAdderTag (desc:string=null, disabled:boolean=false) {
    return (
        <div key="adder" data-dummy={this.refresherValue_} className="flex flex-col items-center">
          <div className="cursor-pointer ">
            <img
              className={(this.isFull())? 'hidden':''}
              src="/assets/icons/image-adder.svg"
              onClick={
                  (e) => {
                    if (disabled)
                      return;

                    const newInfo = this.imgInfos_[this.size_];
                    if (!newInfo)
                      return;

                    newInfo.fileRef.current.click();
                    this._refresh();
                  }
              }
            />
          </div>
          {(desc===null)? null:
            (
              <span className="mt-[12px] text-[15px] text-[#000000]">
                {desc}
              </span>
            )
          }
        </div>
    );
  }

  private _addImgInfo (idx) {
    if (this.size_ >= this.imgInfos_.length || idx < this.size_ || idx >= this.imgInfos_.length)
      return;


    /// move to last
    // pick info
    const info = this.imgInfos_[idx];
    info.src = null;
    info.needUpload = true;

    // push
    for (let ii=this.size_; ii<idx; ++ii)
      this.imgInfos_[ii+1] = this.imgInfos_[ii];

    // set last
    this.imgInfos_[this.size_] = info;

    // reset indices
    for (let ii=0; ii<this.imgInfos_.length; ++ii)
      this.imgInfos_[ii].idx = ii;


    /// increase
    this.size_ = Math.min(this.size_+1, this.imgInfos_.length);
  }

  private _rmImgInfo (idx:number) {
    if (idx < 0 || idx >= this.size_)
      return;


    /// move to tail
    // pick info to del
    const infoToDel = this.imgInfos_[idx];
    infoToDel.key = this._issueKey();
    infoToDel.src = null;
    infoToDel.needUpload = true;

    // pull
    for (let ii=idx+1; ii<this.imgInfos_.length; ++ii)
      this.imgInfos_[ii-1] = this.imgInfos_[ii];

    // set tail
    this.imgInfos_[this.imgInfos_.length-1] = infoToDel;

    // reset indices
    for (let ii=0; ii<this.imgInfos_.length; ++ii)
      this.imgInfos_[ii].idx = ii;


    /// decrease
    this.size_ = Math.max(this.size_-1, 0);
  }
};
